import { Link } from "react-router-dom";
import { React, useContext } from 'react';

export default function EventCard({ locationData, data }) {
  return (
    <div className="fw-bold mb-4" style={{ width: '100%', maxWidth: '400px', minWidth: '300px' }}>
      <Link
        to={`../locations/event/${locationData.name.replace(/ /g, '-').toLowerCase()}`}
        state={{
          id: locationData.id,
          currentLocation: locationData,
        }}
        className="event-card d-block panel-2 position-relative"
        style={{
          borderRadius: "16px",
          textDecoration: "none",
          color: "inherit",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          padding: "1.5rem",
          background: "linear-gradient(145deg, #ffffff, #f5f5f5)",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08)'
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div className="h3 mb-3 text-center" style={{fontWeight: 'bold'}}>{locationData.name}</div>

        <div 
          className="my-2" 
          style={{
            height: "1px",
            background: "linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.05) 100%)"
          }}
        />

        <div className="text-center d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "160px" }}>
          <img
            src={require(`../../clients/${locationData.logoPath}`)}
            alt="logo"
            style={{ 
              width: "180px", 
              height: "180px",
              objectFit: "contain",
              borderRadius: "20px",
            }}
          />
          {/* <div className="text-muted mb-1">Current Count</div>
          <div
            style={{ fontSize: "4.8rem" }}
            className="mb-2 text-gray"
          >
            {data.totalCount || 0}
          </div> */}
          {/* Optional: Show exits too */}
          {/* {data.totalCountOut !== undefined && (
            <div className="text-muted small">
              Exits: {data.totalCountOut}
            </div>
          )} */}
        </div>
      </Link>

      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(0.95);
              box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
            }
            
            70% {
              transform: scale(1);
              box-shadow: 0 0 0 6px rgba(255, 193, 7, 0);
            }
            
            100% {
              transform: scale(0.95);
              box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
            }
          }
        `}
      </style>
    </div>
  );
}